import * as net from "../vipa/net";

export class Case {
    constructor() {
        $("#main").on("click", ".customFile-addKey", this.clickAdd);
        $("#custom_files").on("click", ".customFile-uploadFile", this.clickUpload);
        $("#custom_files").on("click", ".customFile-deleteFile", this.clickDelete);
    }

    clickAdd = (event: JQuery.ClickEvent) => {
        let key_name = prompt("Insert key name");
        if (!key_name) {
            return
        }

        let data = new FormData();
        data.append('action', 'create');
        data.append('key', key_name);
        let url;
        if (globalThis.lang) {
            url = `/${globalThis.lang}/j/update-custom-file/`;
        } else {
            url = "/j/update-custom-file/";
        }
        net.postFormData(
            url,
            data,
            (data: any) => {
                this.clickSuccess(data.result)
            }
        ).fail(this.clickFail);
    }

    clickUpload = (event: JQuery.ClickEvent) => {
        let key = this.getCustomFileKey(event);
        let lang_id = $(event.currentTarget).data("lang-id");

        var input = document.createElement('input');
        input.type = 'file';
        input.accept = 'application/pdf';

        input.onchange = e => {
            let file = e.target.files[0];

            let data = new FormData();
            data.append('action', 'upload');
            data.append('key', key);
            data.append('lang_id', lang_id);
            data.append('extension', file.name.split('.').pop());
            data.append('file', file);
            let url;
            if (globalThis.lang) {
                url = `/${globalThis.lang}/j/update-custom-file/`;
            } else {
                url = "/j/update-custom-file/";
            }
            net.postFormData(
                url,
                data,
                (data: any) => {
                    this.clickSuccess(data.result)
                }
            ).fail(this.clickFail);
        }

        input.click();
    }

    clickDelete = (event: JQuery.ClickEvent) => {
        let key = this.getCustomFileKey(event);
        let lang_id = $(event.currentTarget).data("lang-id");
        let extension = $(event.currentTarget).data("extension");
        let data = new FormData();
        data.append('action', 'delete');
        data.append('key', key);
        data.append('lang_id', lang_id);
        data.append('extension', extension);
        let url;
        if (globalThis.lang) {
            url = `/${globalThis.lang}/j/update-custom-file/`;
        } else {
            url = "/j/update-custom-file/";
        }
        net.postFormData(
            url,
            data,
            (data: any) => {
                this.clickSuccess(data.result)
            }
        ).fail(this.clickFail);
    }

    clickSuccess(result: JQuery.PlainObject): void {
        window.location = window.location;
    }

    clickFail(response: JQuery.jqXHR): void {
        let modal = $("#modal-small");
        let content = $("#modal-small div");

        content.html(response.responseJSON.error);
        modal.foundation("open");
        $(document).on('closed.zf.reveal', function () {
            location.reload();
        });
    }

    private getCustomFileKey(event: JQuery.KeyDownEvent | JQuery.ClickEvent): string {
        return $(event.currentTarget)
            .closest(".custom-file")
            .data("key")
    }
}
